import {DocumentNode, MutationHookOptions, useMutation} from '@apollo/client';
import {FetchResult} from '@apollo/client/link/core';
import {useEffect, useState} from 'react';
import {BehaviorSubject, Observable} from 'rxjs';

type Mutation$<Input, Result> = {
    lastRun$: Observable<Date | null>;
    isRunning$: Observable<boolean>;
    execute: (inputOverrides?: MutationHookOptions<Result, Input>) => Promise<FetchResult<Result>>;
    data: Result | null | undefined;
};
export const useMutation$ = <Input, Result>(
    mutation: DocumentNode,
    options?: MutationHookOptions<Result, Input>,
): Mutation$<Input, Result> => {
    const [lastRun$] = useState(new BehaviorSubject<Date | null>(null));
    const [isRunning$] = useState(new BehaviorSubject<boolean>(false));

    const [execute, {data, loading}] = useMutation<Result, Input>(
        mutation, {
            ...options,
            notifyOnNetworkStatusChange: true,
            onCompleted: () => lastRun$.next(new Date()),
        });
    useEffect(() => {
        if (loading !== isRunning$.getValue()) {
            isRunning$.next(loading);
        }
    }, [loading, isRunning$]);


    return {
        lastRun$: lastRun$ as Observable<Date | null>,
        isRunning$: isRunning$ as Observable<boolean>,
        execute,
        data,
    };
};
